export default __webpack_public_path__ + "static/media/ObjektivMk1_Trial_MdIt.5a34b439.ttf";